import { call, put, select, takeLatest } from 'redux-saga/effects'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { getPcrIdSelector } from '../../../home/selectors'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { IPcr } from '../../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../../user/selectors'
import { getVentilatorSelector } from '../selectors'
import { saveVentilator } from '../store/ventilator.actions'
import { VentilatorConstants } from '../store/ventilator.constants'
import { IVentilatorState } from '../store/ventilator.types'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'

export function* setSuccessfulAttempt() {
  const ventilatorState: IVentilatorState = yield select(getVentilatorSelector)
  const { successfulAttempt } = ventilatorState
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    try {
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      if (pcrDoc.patient?.ventilatorStateList && pcrDoc.patient?.ventilatorStateList.length) {
        const index = pcrDoc.patient?.ventilatorStateList?.findIndex(
          (ventilator) => ventilator.key === ventilatorState.key
        )
        if (index !== -1) {
          if (pcrDoc.patient.ventilatorStateList[index].successfulAttempt !== successfulAttempt) {
            yield put(saveVentilator())
          }
        }
      } else {
        yield put(saveVentilator())
      }
    } catch (e) {
      yield put(throwPcrException(`setSuccessfulAttempt() error: ${e}`))
    }
  } else {
    // todo: add to audit log
  }
}

export function* setSuccessfulAttemptSaga() {
  yield takeLatest([VentilatorConstants.SET_SUCCESSFUL_ATTEMPT], performWithMutexHOG, setSuccessfulAttempt)
}
